import * as React from 'react';
import { Route, Routes, useParams } from 'react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';
import { queryClient } from 'common/react-query/query-client';
import { getProjectId, getWorkspaceId } from 'common/report/util';
import { ReactErrorBoundary } from 'common/components/react-error-boundary';
import { userCookieUtils } from 'common/report/util/user-identity-from-cookie';
import styles from './index.module.styl';
import { HeatMapPage } from './components/page';
type ViewProps = {
  projectId: number;
  workspaceId: number;
};
const View: React.FC<ViewProps> = props => {
  var _userCookieUtils$getU, _userCookieUtils$getU2;
  const {
    heatmapId: heatMapId
  } = useParams<{
    heatmapId: string;
  }>();
  const [searchParams] = useSearchParams();
  const sessionReplayUrl = searchParams.get("session-replay-url");
  const decodedSessionReplayUrl = sessionReplayUrl ? decodeURIComponent(sessionReplayUrl) : undefined;
  return <HeatMapPage projectId={props.projectId} workspaceId={props.workspaceId} userId={(_userCookieUtils$getU = (_userCookieUtils$getU2 = userCookieUtils.getUserIdentityFromCookie()) === null || _userCookieUtils$getU2 === void 0 ? void 0 : _userCookieUtils$getU2.id) !== null && _userCookieUtils$getU !== void 0 ? _userCookieUtils$getU : 0} heatMapId={heatMapId!} sessionReplayUrl={decodedSessionReplayUrl} data-sentry-element="HeatMapPage" data-sentry-component="View" data-sentry-source-file="index.tsx" />;
};

// for lazy loading route
// eslint-disable-next-line import/no-default-export
export default function () {
  const projectId = parseInt(getProjectId(), 10);
  const workspaceId = parseInt(getWorkspaceId(), 10);
  return <div className={styles.appContainer}>
      <ReactErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <Routes>
            <Route path=':heatmapId' element={<View projectId={projectId} workspaceId={workspaceId} />} />
            <Route path='' element={<View projectId={projectId} workspaceId={workspaceId} />} />
          </Routes>
        </QueryClientProvider>
      </ReactErrorBoundary>
    </div>;
}